import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';
import { isProd, isTestEnvironment } from './src/lib/environment';

const urlParams = new URLSearchParams(window.location.search);

if ((isProd && !isTestEnvironment) || urlParams.get('analytics') === 'enabled') {
    const customerIoWriteKey = isProd ? 'b9ebd7ca63967c0da5da' : 'aec4f8ebf10b2f35cd33';

    // Use a non-default global key so the SDK doesn't write `_cdn` onto window.analytics,
    // which Segment's standalone init would otherwise read and use as its CDN.
    window.customerIO = AnalyticsBrowser.load(
        {
            writeKey: customerIoWriteKey,
            cdnURL: 'https://cdp-eu.customer.io'
        },
        {
            globalAnalyticsKey: 'customerIO',
            cookie: { domain: window.location.hostname }
        }
    );

    const anonymousId = urlParams.get('anonymousId');
    if (anonymousId) {
        window.customerIO.setAnonymousId(anonymousId);
    }

    window.customerIO.page();
}
